var crossfetch = require('cross-fetch');

var BASE_API_PATH = "https://api.countapi.xyz";
var validPattern = /^[A-Za-z0-9_\-.]{3,64}$/;
var validRegex = new RegExp(validPattern);

var validatePath = module.exports.validatePath = function (namespace, key) {
  if (typeof key === "undefined") {
    if (typeof namespace === "undefined") {
      return Promise.reject("Missing key");
    }

    key = namespace;
    namespace = undefined;
  }

  function validName(name) {
    return validRegex.test(name) || name === ':HOST:' || name === ':PATHNAME:';
  }

  return new Promise(function (resolve, reject) {
    if (!validName(key)) {
      reject("Key must match ".concat(validPattern, ". Got '").concat(namespace, "'"));
      return;
    }

    if (!validName(namespace) && typeof namespace !== "undefined" && namespace !== null) {
      reject("Namespace must match ".concat(validPattern, " or be empty. Got '").concat(namespace, "'"));
      return;
    }

    var path = '';
    if (typeof namespace !== "undefined") path += namespace + '/';
    path += key;
    resolve({
      path: path
    });
  });
};

var validateTuple = module.exports.validateTuple = function (namespace, key, value) {
  if (typeof value === "undefined") {
    if (typeof key === "undefined") {
      return Promise.reject("Missing key or value");
    }

    value = key;
    key = undefined;
  }

  if (typeof value !== "number") {
    return Promise.reject("Value is NaN");
  }

  return validatePath(namespace, key).then(function (result) {
    return Object.assign({}, {
      value: value
    }, result);
  });
};

function finalize(res) {
  var valid_responses = [200, 400, 403, 404];

  if (valid_responses.includes(res.status)) {
    return res.json().then(function (json) {
      if (res.status == 400) return Promise.reject(json.error);
      return Object.assign({}, {
        status: res.status,
        path: res.headers.get('X-Path')
      }, json);
    });
  }

  return Promise.reject("Response from server: " + res.status);
}

function queryParams(params) {
  return Object.keys(params || {}).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
}

module.exports.get = function (namespace, key) {
  return validatePath(namespace, key).then(function (result) {
    return crossfetch("".concat(BASE_API_PATH, "/get/").concat(result.path)).then(finalize);
  });
};

module.exports.set = function (namespace, key, value) {
  return validateTuple(namespace, key, value).then(function (result) {
    return crossfetch("".concat(BASE_API_PATH, "/set/").concat(result.path, "?value=").concat(result.value)).then(finalize);
  });
};

module.exports.update = function (namespace, key, amount) {
  return validateTuple(namespace, key, amount).then(function (result) {
    return crossfetch("".concat(BASE_API_PATH, "/update/").concat(result.path, "?amount=").concat(result.value)).then(finalize);
  });
};

module.exports.hit = function (namespace, key) {
  return validatePath(namespace, key).then(function (result) {
    return crossfetch("".concat(BASE_API_PATH, "/hit/").concat(result.path)).then(finalize);
  });
};

module.exports.info = function (namespace, key) {
  return validatePath(namespace, key).then(function (result) {
    return crossfetch("".concat(BASE_API_PATH, "/info/").concat(result.path)).then(finalize);
  });
};

module.exports.create = function (options) {
  var params = queryParams(options);
  return crossfetch("".concat(BASE_API_PATH, "/create").concat(params.length > 0 ? '?' + params : '')).then(finalize);
};

module.exports.stats = function () {
  return crossfetch("".concat(BASE_API_PATH, "/stats")).then(finalize);
};

module.exports.visits = function (page) {
  return this.hit(':HOST:', page ? page : ':PATHNAME:');
};

module.exports.event = function (name) {
  return this.hit(':HOST:', name);
};